import { css } from '@emotion/css';
import { theme } from 'antd';
import Mark from 'mark.js';
import type React from 'react';
import { type ReactNode, useEffect, useRef } from 'react';
import { tokenize } from '../utils/tokenSearch.ts';

const { useToken } = theme;

export interface MarkableProps {
  children: ReactNode;
  tokens: string[] | string;
}

const useMarkableClassNames = () => {
  const { token } = useToken();
  return {
    mark: css`
      mark {
        background-color: ${token['gold-3']};
        padding: 0;
      }
    `,
  };
};

export const Markable: React.FC<MarkableProps> = ({ tokens, children }) => {
  const container = useRef<HTMLSpanElement>(null);
  const styles = useMarkableClassNames();

  useEffect(() => {
    const currentRef = container.current;
    if (currentRef && children) {
      const instance = new Mark(currentRef);
      instance.mark(typeof tokens === 'string' ? tokenize(tokens) : tokens);
      return () => {
        instance.unmark();
      };
    }
  }, [tokens, children]);

  return (
    <span ref={container} className={styles.mark}>
      {children}
    </span>
  );
};
